module.exports = __webpack_public_path__ + "img/4.cf16071b.jpg";